var CartSmartPolicy = {
  group(type, title) {
    const t=((type||'').split('[')[0]+' '+(title||'')).toLowerCase();
    if (/shaker/.test(t)) return 'shaker';
    if (/kollagen|collagen/.test(t)) return 'other';
    if (/creatin|kreatin/.test(t)) return 'creatine';
    if (/rice pudding|reispudding/.test(t)) return 'rice';
    if (/functional food|flavour|flavor|chunky/.test(t)) return 'flavour';
    if (/elektrolyt|electrolyt/.test(t)) return 'hydration';
    if (/eaa|bcaa/.test(t)) return 'amino';
    if (/dextrin|carbo/.test(t)) return 'carbs';
    if (/whey|protein|casein/.test(t)) return 'protein';
    if (/booster|citrullin|pre.?workout/.test(t)) return 'training';
    return 'other';
  },
  choose(cart, candidates) {
    if (cart.unknownBundle) return [];
    const groups=new Set(cart.items.map(x=>this.group(x.type,x.title)));
    const ids=new Set(cart.items.map(x=>String(x.id)));
    const gap=Math.max(0,cart.threshold-cart.total);
    const cap=gap>0?Math.max(3000,gap+1000):3000;
    const complements={
      shaker:['protein','creatine','amino','hydration','carbs','training'],
      protein:['creatine','rice','shaker','flavour','carbs'],
      creatine:['protein','shaker'],
      rice:['protein','flavour'],
      flavour:['rice'],
      hydration:['creatine','amino','carbs','shaker','training'],
      amino:['carbs','hydration','shaker'],
      carbs:['creatine','amino','hydration','training']
    };
    const relevant=candidates.filter(x=>{
      const group=this.group(x.type,x.title);
      if (ids.has(String(x.id))||x.available===false||x.price<=0||x.price>cap||groups.has(group)||group==='other') return false;
      return (complements[group]||[]).some(present=>groups.has(present));
    });
    relevant.sort((a,b)=>gap>0?(Math.abs(a.price-gap)-Math.abs(b.price-gap)||a.price-b.price||Number(this.group(b.type,b.title)==='shaker')-Number(this.group(a.type,a.title)==='shaker')):a.price-b.price);
    const chosen=[],seen=new Set();
    const limit=cart.threshold>0&&gap===0?1:2;
    for(const x of relevant){const group=this.group(x.type,x.title);if(!seen.has(group)){chosen.push(x);seen.add(group);}if(chosen.length===limit)break;}
    return chosen;
  }
};
if(typeof document!=='undefined')customElements.define('cart-smart-recommendations',class extends HTMLElement{
 connectedCallback(){
  const context=JSON.parse(this.querySelector('[data-cart-context]').textContent);
  const templates=[...this.querySelectorAll('template[data-candidate]')];
  const selected=CartSmartPolicy.choose(context,templates.map(t=>({id:t.dataset.productId,type:t.dataset.productType,title:t.dataset.productTitle,price:Number(t.dataset.price),available:true,template:t})));
  const target=this.querySelector('[data-smart-cards]');
  target.replaceChildren(...selected.map(x=>x.template.content.cloneNode(true)));
  this.hidden=selected.length===0;
 }
});
